(() => {
  const OPT = {
    enabledAttr: 'data-runink-mug',
    enabledVal: 'enabled',
    fieldsSel: '#runink_mug_fields',
    optNames: ['PERSONALIZATION', 'Personalization'],
    yesVal: 'YES'
  };

  const qs = (r, s) => r.querySelector(s);
  const qsa = (r, s) => Array.from(r.querySelectorAll(s));

  const getOptionSelect = (vs) => {
    for (const n of OPT.optNames) {
      const sel = qs(vs, `select[name="options[${CSS.escape(n)}]"]`);
      if (sel) return sel;
    }
    return null;
  };

  const getRoot = (vs) =>
    vs.closest('.product__info-wrapper') ||
    vs.closest('product-info') ||
    vs.closest('section') ||
    document;

  const apply = (vs) => {
    const root = getRoot(vs);
    const fields = qs(root, OPT.fieldsSel);
    if (!fields) return;

    const persSel = getOptionSelect(vs);
    if (!persSel) return;

    fields.style.display = (String(persSel.value).trim() === OPT.yesVal) ? '' : 'none';
  };

  const initOne = (vs) => {
    if (!vs || vs.getAttribute(OPT.enabledAttr) !== OPT.enabledVal) return;
    if (vs.dataset.runinkMugInit === '1') return;
    vs.dataset.runinkMugInit = '1';

    const persSel = getOptionSelect(vs);
    if (!persSel) return;

    persSel.addEventListener('change', () => apply(vs));
    vs.addEventListener('change', () => apply(vs));

    apply(vs);
  };

  const boot = () => {
    qsa(document, `variant-selects[${OPT.enabledAttr}="${OPT.enabledVal}"]`).forEach(initOne);

    const mo = new MutationObserver(() => {
      qsa(document, `variant-selects[${OPT.enabledAttr}="${OPT.enabledVal}"]`).forEach(initOne);
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
